// Self-hosted cookie consent for merchant storefronts.
//
// Replaces the old third-party CookieScript: this bundle is first-party, so it
// works on merchant custom domains at no extra cost and the consent record
// stays with us. Everything is configured from the server (CookieConsentHelper)
// and injected as JSON, so each merchant gets their own language and copy.
//
// Scripts that need consent are marked up as
//   <script type="text/plain" data-category="analytics" ...>
// and the library switches them on only once the visitor allows that category.

import * as CookieConsent from "vanilla-cookieconsent"
import "vanilla-cookieconsent/dist/cookieconsent.css"

// The "Cookie settings" link in the storefront footer reopens the modal.
window.CookieConsent = CookieConsent

function startCookieConsent() {
  const configElement = document.getElementById("cc-config")
  if (!configElement) return

  let config
  try {
    config = JSON.parse(configElement.textContent)
  } catch (error) {
    // A broken config must not take the shop down with it.
    console.error("Cookie consent config could not be parsed", error)
    return
  }

  CookieConsent.run(config)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startCookieConsent)
} else {
  startCookieConsent()
}
